
import * as React from 'react';
import './Partner.css';

class Partner extends React.PureComponent {
  render(): JSX.Element {
    return (

      <section id="clients" className="clients pad-80">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
              <h2 className="lg-title text-center">
                <span>Our Partners</span>
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div id="client-slider" className="client-slider">
                <div className="item col-md-3 col-sm-6 col-xs-12">
                  <img src="assets/images/partners/partner-1.png" alt="clients logo" />
                </div>
                <div className="item col-md-3 col-sm-6 col-xs-12">
                  <img src="assets/images/partners/partner-2.jpg" alt="clients logo" />
                </div>
                <div className="item col-md-3 col-sm-6 col-xs-12">
                  <img src="assets/images/partners/partner-3.png" alt="clients logo" />
                </div>
                <div className="item col-md-3 col-sm-6 col-xs-12">
                  <img src="assets/images/partners/partner-4.png" alt="clients logo" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Partner;



// WEBPACK FOOTER //
// ./src/components/Partner.tsx